import React from "react";
import { Sidebar } from "./Sidebar";
import { Dashboard } from "./Dashboard";
import { useResetStore } from "../../../hooks/useResetStore";

export const DashboardPage: React.FC = () => {
  useResetStore();
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  return (
    <div className="h-screen print:hidden flex overflow-hidden bg-white">
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      <Dashboard setSidebarOpen={setSidebarOpen} />
    </div>
  );
};
